import { render, staticRenderFns } from "./TagPolygons.vue?vue&type=template&id=e6735b10&scoped=true"
import script from "./TagPolygons.vue?vue&type=script&lang=js"
export * from "./TagPolygons.vue?vue&type=script&lang=js"
import style0 from "./TagPolygons.vue?vue&type=style&index=0&id=e6735b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6735b10",
  null
  
)

export default component.exports